/**
 * VideoControl
 * Embeds a video player. Supports URL or embed-code src.
 * Performance: Memoized to prevent unnecessary re-renders
 */

import React, { memo } from 'react';
import type { ControlRendererProps } from '../ControlRenderer';

export const VideoControl = memo((props: ControlRendererProps) => {
  const { control, value } = props;
  const src = (typeof value === 'string' && value)
    || (control.config?.src as string)
    || (control as any).src as string | undefined
    || (control.defaultValue as string);

  if (!src) return <div className="af-video-control af-video-control--empty">No video source</div>;

  return (
    <div className="af-video-control" data-control-id={control.id}>
      {control.label && <p className="af-video-control__label">{control.label}</p>}
      <video
        src={src}
        controls={control.config?.controls !== false && (control as any).controls !== false}
        autoPlay={(control.config?.autoPlay ?? (control as any).autoPlay) === true}
        loop={(control.config?.loop ?? (control as any).loop) === true}
        style={{ maxWidth: '100%' }}
      />
    </div>
  );
});

VideoControl.displayName = 'VideoControl';

export default VideoControl;
